import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export const alertVariantList = {
  color: {
    default: 'border-neutral-200 bg-background text-neutral-800 [&>h5+div]:text-neutral-600 [&>svg]:text-neutral-800',
    destructive: 'border-error-200 bg-error-50 text-error-600 [&>svg]:text-error-600',
    info: 'border-info-200 bg-info-50 text-info-600 [&>svg]:text-info-600',
    warning: 'border-warning-200 bg-warning-50 text-warning-600 [&>svg]:text-warning-600',
    success: 'border-success-200 bg-success-50 text-success-600 [&>svg]:text-success-600',
  },
}

export const alertVariants = cva(
  [
    'relative',
    'w-full',
    'rounded-lg',
    'border',
    'p-4',
    '[&>[data-alert-icon]+div]:translate-y-[-3px]',
    '[&>[data-alert-icon]~*:not([data-close-button])]:pl-7',
  ],
  {
    variants: alertVariantList,
    defaultVariants: {
      color: 'default',
    },
  },
)
export type AlertVariants = VariantProps<typeof alertVariants>

export const alertIconVariantList = {
  position: {
    left: 'left-4',
    right: 'right-4',
  },
}

export const alertIconVariants = cva(
  [
    'absolute',
    'top-[15px]',
  ],
  {
    variants: alertIconVariantList,
    defaultVariants: {
      position: 'left',
    },
  },
)
export type AlertIconVariants = VariantProps<typeof alertIconVariants>
